import React from 'react';
import { StyledBadge } from './styles';
import { BadgeProps } from './types';

const Badge: React.FC<BadgeProps> = ({
  variant,
  children,
  size = 'medium',
}) => {
  return (
    <StyledBadge variant={variant} size={size}>
      {children}
    </StyledBadge>
  );
};

export default Badge;
